<template>
  <div class="login">
    <h1>Storing login info...</h1>
  </div>
</template>

<script lang="ts">
import AuthStore from "@/AuthStore";
import { Logger } from "@iloq/shared";
import { defineComponent } from "vue";
import { mapActions } from "vuex";

export default defineComponent({
  name: "TokenReceiver",
  props: {
    authToken: {
      type: String,
      required: true,
    },
    refreshToken: {
      type: String,
      required: true,
    },
    azureAdToken: {
      type: String,
      required: true,
    },
  },
  mounted() {
    AuthStore.removeLogin();
    this.saveTokens({
      authToken: this.authToken,
      refreshToken: this.refreshToken,
      azureAdToken: this.azureAdToken,
    })
      .then(() => {
        Logger.debug("tokens saved");
        this.$router.push({ name: "home" }).catch((err: any) => {
          // Ignore silly error from redirects
          if (err.message?.includes("Redirected when going from ")) {
            return;
          }
          throw err;
        });
      })
      .catch((err) => {
        Logger.error("Error saving tokens:", err);
      });
  },
  methods: {
    ...mapActions(["saveTokens"]),
  },
});
</script>
